import axios from "axios";

import { activeLocale } from "@/5-shared/utils/activeLocale";

import { API_URL } from "./apiUrl";

export const http = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  validateStatus: (status: number) => status >= 200 && status < 300,
});

// Every request carries the active UI locale (mirrored by I18nProvider) without each
// call site threading a `language` argument. Django's LocaleMiddleware reads
// `Accept-Language` and activates it for the response (e.g. the followup PDF/email).
http.interceptors.request.use((config) => {
  config.headers.set("Accept-Language", activeLocale());
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err: unknown) => Promise.reject(err instanceof Error ? err : new Error(String(err))),
);
